"use client";

import { c as _c } from "react/compiler-runtime";
import { FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../tests/types";
interface CloseButtonProps {
  onClick: () => void;
  className?: string;
  "data-testid"?: string;
}
export const CloseButton = t0 => {
  const $ = _c(5);
  const {
    onClick,
    className,
    "data-testid": dataTestId
  } = t0;
  const t1 = dataTestId || TestIdEnum.CloseButton;
  const t2 = `flex items-center justify-center w-7 h-7 rounded-full bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-700 text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors ${className}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FiX className="w-4 h-4" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== onClick || $[2] !== t1 || $[3] !== t2) {
    t4 = <button data-testid={t1} onClick={onClick} className={t2} aria-label="Close">{t3}</button>;
    $[1] = onClick;
    $[2] = t1;
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};